import { Button } from '@client:common/button';
import { Ripple } from '@client:common/effects/ripple';

import { Dialog } from './Dialog';

import './ConfirmationDialog.light.scss';
import './ConfirmationDialog.dark.scss';

export class ConfirmationDialog {
  static open(message: string) {
    return new Promise<void>(resolve => {
      const dialogRef = Dialog.create(message)
        .addClassName('confirmation-dialog')
        .transparentBackdrop()
        .dismissible()
        .addButton(
          <Button
            style='basic'
            color='primary'
            onClick={() => {
              dialogRef.close();
            }}>
            <Ripple />
            Cancel
          </Button>
        )
        .addButton(
          <Button
            style='raised'
            color='primary'
            onClick={() => {
              dialogRef.close();
              resolve();
            }}>
            <Ripple />
            Confirm
          </Button>
        )
        .open();
    });
  }

}
